var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandLined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0609 12L10.0278 18.0304L8.96741 16.9696L13.9391 12L8.96741 7.03044L10.0278 5.96955L16.0609 12Z",
    fill: "#1F2328"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandLined);
export default __webpack_public_path__ + "static/media/expand-lined.896073b51d34402b7ece8e452ed14f39.svg";
export { ForwardRef as ReactComponent };